import { render, staticRenderFns } from "./selo-protocolo.vue?vue&type=template&id=4d472d0c&scoped=true"
import script from "./selo-protocolo.vue?vue&type=script&lang=ts"
export * from "./selo-protocolo.vue?vue&type=script&lang=ts"
import style0 from "./selo-protocolo.vue?vue&type=style&index=0&id=4d472d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d472d0c",
  null
  
)

export default component.exports